import MediaList from './mediaList';

export default MediaList;
